import { render, staticRenderFns } from "./BlogDetails.vue?vue&type=template&id=6fd55c05&scoped=true"
import script from "./BlogDetails.vue?vue&type=script&lang=js"
export * from "./BlogDetails.vue?vue&type=script&lang=js"
import style1 from "./BlogDetails.vue?vue&type=style&index=1&id=6fd55c05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd55c05",
  null
  
)

export default component.exports